<template>
  <section v-if="status && status.allowed" class="test-day-controls" aria-label="内部测试天数控制">
    <div class="test-day-heading"><strong>内部测试</strong><span>仅测试账号可用</span></div>
    <p v-if="status.sequence" class="test-day-number">第 {{ status.sequence }} / {{ status.totalDays }} 天</p>
    <p v-if="status.sequence">当天任务 {{ status.completedCards }} / {{ status.totalCards }} 已完成</p>
    <p role="status">{{ status.message }}</p>
    <p class="test-day-note">只模拟治疗天数，不更改手机时间，不跳过未完成任务。</p>
    <div class="test-day-actions">
      <button type="button" :disabled="busy || loading" @click="refresh">刷新状态</button>
      <button type="button" class="test-day-advance" :disabled="!status.canAdvance || busy || loading" @click="advance">
        {{ busy ? '正在进入...' : '进入下一天' }}
      </button>
    </div>
    <p v-if="error" class="test-day-error" role="alert">{{ error }}</p>
  </section>
</template>

<script>
import { Dialog } from 'vant';
import request from '@/utils/request';

export default {
  name: 'TestDayControls',
  data: () => ({ status: null, busy: false, loading: false, error: '' }),
  mounted() { this.refresh(); },
  activated() { this.refresh(); },
  methods: {
    async refresh() {
      if (this.loading || this.busy) return;
      this.loading = true;
      try {
        this.status = await request.get('/app-api/api/treatment/test-clock/status');
        this.error = '';
      } catch (error) {
        if (this.status?.allowed) this.error = '状态加载失败，请重试。';
      } finally {
        this.loading = false;
      }
    },
    async advance() {
      if (this.busy || this.loading || !this.status?.canAdvance) return;
      this.busy = true;
      this.error = '';
      try {
        await Dialog.confirm({ title: '模拟进入下一天', message: `已完成第${this.status.sequence}天全部任务。进入下一天后保留已有记录，不能通过此按钮回退。`, confirmButtonText: '进入下一天' });
      } catch (_) {
        this.busy = false;
        return;
      }
      try {
        const snapshot = this.status;
        this.status = await request.post(`/app-api/api/treatment/cyr-experimental/${snapshot.instanceId}/test-clock/advance`, {
          data: { dayInstanceId: snapshot.dayInstanceId, sequence: snapshot.sequence }, timeout: 60000,
        });
        await this.$router.replace('/layout/dialogue');
        // Drop cached daily context so the new day's authoritative task is loaded.
        window.location.reload();
      } catch (error) {
        this.error = error?.data?.msg || error?.response?.data?.msg || '推进未确认成功，请刷新状态后返回对话查看，不要连续重试。';
      } finally {
        this.busy = false;
        this.refresh();
      }
    },
  },
};
</script>

<style scoped>
.test-day-controls { margin-top: 20px; padding: 18px; border: 1px solid #b7d8ee; border-radius: 14px; background: linear-gradient(135deg, #eef8ff, #f6fbff); color: #34536b; font-size: 14px; }
.test-day-heading { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.test-day-heading strong { font-size: 17px; }
.test-day-heading span { font-size: 11px; color: #638098; }
.test-day-number { margin: 16px 0 8px; font-size: 24px; font-weight: 600; color: #2266a6; }
.test-day-controls p { line-height: 1.6; }
.test-day-note { color: #6b7e90; font-size: 12px; }
.test-day-actions { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 14px; }
.test-day-actions button { flex: 1; min-width: 110px; border: 1px solid #b7d8ee; border-radius: 20px; padding: 10px; background: white; color: #2869a7; font: inherit; cursor: pointer; }
.test-day-actions .test-day-advance { background: #3479bf; color: white; border-color: #3479bf; }
.test-day-actions button:disabled { opacity: .45; cursor: not-allowed; }
.test-day-error { color: #a34735; }
</style>
